import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  useMediaQuery,
  Box,
} from '@mui/material'
import MainHeader from '../shared/organism/MainHeader'
import React, {useState} from 'react'
import AccSecurity from '../shared/molecule/AccSecurity'
import { theme } from '../../theme/DashboardTheme'
import { ExpandMore } from '@mui/icons-material'
import PageLayout from './PageLayout'

interface TabBarProps {
  selectedTab: number
  onTabChange: (tabIndex: number) => void
}

const TabBar: React.FC<TabBarProps> = ({ selectedTab, onTabChange }) => {
  const tabs = ['Account & Security']

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-end',
        width: '100%',
        height: { sm: '35px', md: '45px' },
        marginTop: '50px',
        paddingTop: 3,
        marginBottom: 3,
      }}>
      <Box sx={{ display: 'flex', gap: 3 }}>
        {tabs.map((tab, index) => (
          <Box
            key={index}
            onClick={() => onTabChange(index)}
            sx={{
              px: { md: 1, lg: 2 },
              height: '65px',
              display: 'flex',
              alignItems: 'center',
              cursor: 'pointer',
              color: index === selectedTab ? '#9135E0' : '#6B7280',
              fontSize: { sm: 15, md: 18, lg: 20 },
              fontFamily: index === selectedTab ? 'InterMedium' : 'InterRegular',
              fontWeight: index === selectedTab ? 500 : 400,
              borderBottom: index === selectedTab ? '2px solid #9135E0' : 'none',
            }}>
            {tab}
          </Box>
        ))}
      </Box>
    </Box>
  )
}

export const SettingsView = () => {

  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [selectedTab, setSelectedTab] = useState(0)

  return (
    <PageLayout>
      <MainHeader title={'Settings'} />
      {isMobile ? (
        <div style={{ marginBlock: '1rem' }}>
          <Accordion sx={{boxShadow: 'none'}}>
            <AccordionSummary
              expandIcon={<ExpandMore />}
              aria-controls="panel1-content">
              Account & Security
            </AccordionSummary>
            <AccordionDetails>
              <AccSecurity />
            </AccordionDetails>
          </Accordion>
        </div>
      ) : (
        <>
          <TabBar
            selectedTab={selectedTab}
            onTabChange={setSelectedTab}
          />
          {selectedTab === 0 && <AccSecurity />}
        </>
      )}
    </PageLayout>
  )
}